<template>
  <div
    v-if="isLoadingTimelineAssets && !asset"
    class="playlist-layer flex items-center"
    :class="{ active: (isCurrentLayout || isCurrentSampleLayout)}"
  >
    <div class="playlist-layer__skeleton" />

    <div class="layer-info">
      <button
        class="tb-btn tb-btn-text sm medium-em margin-left-xxs"
        title="Remove item from playlist"
        @click.stop.prevent="removeItem"
      >
        <i class="icon icon-minus-circle"></i>
      </button>
    </div>
  </div>

  <div
    v-else-if="asset"
    class="playlist-layer asset"
    :class="{ editing: isEditing }"
    :data-test="`asset:${asset._id}`"
    @click="onClickTimelineItem"
  >
    <div class="layer-info">

      <button
        class="drag-handle tb-btn tb-btn-link sm low-em"
        title="Rearrange"
      >
        <span class="icon icon-drag-handle" />
      </button>

      <div class="layer-title flex-grow margin-left-xs">
        <img
          class="layer-preview asset-timeline-preview margin-right-xs"
          :src="asset?.thumbnail_url || asset?.media_url"
          :alt="asset.title"
          @error="assetError = true"
        >

        <div class="flex-grow no-wrap--ellipsis">
          <div class="title-text">{{ asset.title }}</div>
          <div class="description-text">{{ asset.asset_type === 'image' ? 'Image only' : 'Video Only'}}</div>
        </div>
      </div>

      <div class="layer-description capitalize margin-left-xxs">
        <duration
          v-if="asset.asset_type === 'image'"
          :duration.sync="item.displayTime"
          class="margin-left-xxs"
        />

        <template v-else>
          <button
            class="tb-btn tb-btn-contained sm medium-em margin-left-xxs margin-right-md play-panel"
            @click.stop="toggleVideo"
          >
            <span
              class="icon"
              :class="{
                'icon-pause': videoPlaying,
                'icon-play': !videoPlaying
              }"
            />
          </button>
        </template>
      </div>

      <preview-live-switch :item="item"></preview-live-switch>

      <dropdown position="left" class="more-actions margin-left-xxs">
        <template slot="trigger">
          <button class="tb-btn tb-btn-text sm medium-em" title="More actions">
            <span class="icon icon-more-vertical" />
          </button>
        </template>

        <template slot="dropdown-body">
          <button
            class="dropdown-list-item"
            @click="duplicateItem"
          >
            <span class="dropdown-list-item-label">
              Duplicate in Playlist
            </span>
          </button>

          <hr>

          <button
            class="dropdown-list-item"
            @click="removeItem"
          >
            <span class="dropdown-list-item-label warning">
              Remove
            </span>
          </button>
        </template>
      </dropdown>
    </div>
  </div>

  <div
    v-else
    class="playlist-layer deleted"
    :class="{ active: (isCurrentLayout || isCurrentSampleLayout)}"
  >
    <div class="layer-info">
      <div class="deleted-message">This asset has been deleted, or failed to load.</div>

      <button
        class="tb-btn tb-btn-text sm medium-em margin-left-xxs"
        title="Remove item from playlist"
        @click.stop.prevent="removeItem"
      >
        <i class="icon icon-minus-circle"></i>
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TimelineMixins from '@/js/mixins/timeline-mixins';
import PreviewLiveSwitch from '../PreviewLiveSwitch.vue';
import duration from './duration-input/DurationInput.vue';

export default {
  name: 'TimelineAssetComponent',
  mixins: [TimelineMixins],
  props: ['item'],

  components: {
    PreviewLiveSwitch,
    duration,
  },

  data() {
    return {
      assetError: false,
    };
  },

  computed: {
    ...mapState('assets', [
      'assetLookupTable',
      'isLoadingTimelineAssets',
    ]),

    asset() {
      return this.item && this.assetLookupTable[this.item._id];
    },
  },
};
</script>

<style lang="scss" scoped>
.asset-timeline-preview {
  width: 100%;
  height: 100%;
  aspect-ratio: 16/9;
  object-fit: cover;
  background-color: #d9d9d9;
}
</style>
